import DatePick_MI from "components/DatePicker_MI";
import React, { useContext, useState } from "react";
import "./OnlyVehicleRemoved.css";

const OnlyVehicleRemoved = ({
  requestContext,
  vehicleContext,
}) => {
  const requestTypeContext = useContext(requestContext);
  const deleteVehicleContext = useContext(vehicleContext);
  const [requestedRemovalEffDate, setRequestedRemovalEffDate] = useState(
    requestTypeContext.getTodaysDate(true)
  );

  return (
    <>
      <p className="vehicleText">This is the only vehicle on your policy!</p>

      <div>
        <div className="radio ms-4">
          <label className="form-check-label vehicleText d-flex align-items-start">
            <input
              className="form-check-input"
              type="radio"
              value={requestTypeContext?.removeVehicleClass.deleteStatus}
              onChange={() => {
                requestTypeContext.updateDeleteStatus(false);
                deleteVehicleContext?.removeVehCallback("vehicleRemovalReason", "")
              }}
              checked={requestTypeContext?.removeVehicleClass.deleteStatus == false}
            />
            <span className="ms-2 flex-grow-1">
              <p>
                I want to remove this vehicle and add a new vehicle to my
                policy.
              </p>
            </span>
          </label>
        </div>
        <div className="radio ms-4">
          <label className="form-check-label vehicleText d-flex align-items-start">
            <input
              className="form-check-input"
              type="radio"
              value={requestTypeContext?.removeVehicleClass.deleteStatus}
              onChange={() => {
                requestTypeContext.updateDeleteStatus(true);
                deleteVehicleContext?.removeVehCallback("vehicleRemovalReason", "I do not want to add a new vehicle and am requesting to cancel my policy.")
              }}
              checked={requestTypeContext?.removeVehicleClass.deleteStatus == true}
            />
            <span className="ms-2 flex-grow-1">
              <p>
                I do not want to add a new vehicle and am requesting to cancel
                my policy.
              </p>
            </span>
          </label>
        </div>
        {requestTypeContext?.removeVehicleClass.deleteStatus == true && (
          <>
            <div className="col-xl-12 justify-content-center">
              <div className="row form-group form-group-sm align-items-center my-4">
                <p className="col-12 col-md-6 col-sm-12 text-primary fw-bold mb-2 mb-md-0 vehicleQuestions">
                  Requested Policy Cancellation Effective Date*
                </p>
                <div className="col-12 col-md-6 col-sm-12">
                  <DatePick_MI
                    dateSubmit={
                      deleteVehicleContext?.deleteVehicle
                        ?.requestedRemovalEffDate
                        ? deleteVehicleContext?.deleteVehicle
                            ?.requestedRemovalEffDate
                        : requestedRemovalEffDate
                    }
                    setDateSubmit={setRequestedRemovalEffDate}
                    storeValue={deleteVehicleContext?.removeVehCallback}
                    nameValue={"requestedRemovalEffDate"}
                    displayCalendar={"bottom-start"}
                  />
                </div>
              </div>
            </div>

            {/* Please Explain Field (Not Required) */}
            <div className='col-xl-12 justify-content-center'>
                <div className="row form-group form-group-sm align-items-center my-4">
                    <p className="col-12 col-sm-6 text-primary fw-bold mb-2 mb-md-0 vehicleQuestions">
                        Please explain...
                    </p>
                    <div className="col-12 col-md-6 col-sm-12">
                        <textarea className="form-control" placeholder="Please explain..."
                            style={{ resize: 'none' }}
                            value={deleteVehicleContext?.deleteVehicle?.vehicleRemovalExplanation ? deleteVehicleContext?.deleteVehicle?.vehicleRemovalExplanation : ""}
                            onChange={(e) => { deleteVehicleContext?.removeVehCallback("vehicleRemovalExplanation", e.target.value) }}
                        />
                    </div>
                </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OnlyVehicleRemoved;
